const React = require('react');
const Section = require('../../Section');

class EditorBox extends React.Component {
    render() {
        const {title, image, body} = this.props;
        return (
        <div className="editorbox">
            <div className="editorbox__container">
                {image && (
                <div className="editorbox__image-container">
                    <img src={image} />
                </div>
                )}
                <div className="editorbox__content-container">
                    {title && (<h2 className="editorbox__title">{title}</h2>)}
                    <div className="editorbox__description" dangerouslySetInnerHTML={{__html: body}} />
                </div>
            </div>
        </div>
        )
    }
}

module.exports = EditorBox;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/editorbox/Component/index.jsx